<template>
    <div class="ion-page">
        <ion-header class="rp-mobile">
            <ion-toolbar class="mobile-header-toolbar">
                <ion-buttons v-slot: start>
                    <ion-menu-button></ion-menu-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-header class="rp-desktop">
            <ion-toolbar>
                <ion-buttons v-slot: start>
                    <ion-back-button default-href="#" @click="navigatePreviousPage" v-if="!displayBackBtn"></ion-back-button>
                    <ion-title class="fontRoboto">Stations List</ion-title>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content>
            <ion-grid>
                <ion-row class="rectangle">
                    <ion-col>
                        <ion-row align-items-stretch>
                            <ion-col size="12" size-md="2">
                                <ion-label class="section-head">Station Name</ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-input
                                    class="form-input"
                                    type="text"
                                    id="name"
                                    @input="name = $event.target.value"
                                    maxlength="50"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="2">
                                <ion-label class="section-head">Address</ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-input
                                    class="form-input"
                                    type="text"
                                    id="city"
                                    @input="city = $event.target.value"
                                    maxlength="100"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="2">
                                <br />
                                <ion-button class="btn-search margin-top-10" @click="searchStations">Search</ion-button>
                                <ion-button class="btn-clear margin-top-10" @click="clearFields">
                                    <ion-icon :icon="refresh"></ion-icon>
                                </ion-button>
                            </ion-col>
                        </ion-row>
                    </ion-col>
                </ion-row>
                <ion-row class="row-divider"></ion-row>
                <ion-row  class="list-head">
                    <ion-col>
                        <ion-label>Station Name</ion-label>
                    </ion-col>
                    <ion-col>
                        <ion-label>City</ion-label>
                    </ion-col>
                    <ion-col>
                        <ion-label>Make</ion-label>
                    </ion-col>
                    <ion-col>
                        <ion-label>Model</ion-label>
                    </ion-col>
                    <ion-col>
                        <ion-label>Activation Date</ion-label>
                    </ion-col>
                    <ion-col>
                        <ion-label>Status</ion-label>
                    </ion-col>
                </ion-row>
                <hr />
                <ion-row class="station-list" v-for="(station) in this.stationsList" :key="station">
                    <ion-col>
                        <ion-label @click="viewStation(station)" button class="ext-link station-name">{{station.name}}</ion-label>
                    </ion-col>
                    <ion-col>
                        <ion-label>{{station.address.city}}</ion-label>
                    </ion-col>
                    <ion-col>
                        <ion-label>{{station.make}}</ion-label>
                    </ion-col>
                    <ion-col>
                        <ion-label>{{station.model}}</ion-label>
                    </ion-col>
                    <ion-col>
                        <ion-label>{{changeDateFormat(station.activationDate)}} (EDT)</ion-label>
                    </ion-col>
                    <ion-col>
                        <ion-label
                        v-bind:class="(station.status.id == 'AV') ? 'avalilable' : (station.status.id == 'OC') ? 'occupied' : (station.status.id == 'UNRH') ? 'unreachable' : 'unavailable' "
                        >{{convertUppercase(station.status.name)}}</ion-label>
                    </ion-col>
                </ion-row>
                <ion-row class="row-divider"></ion-row>
                <ion-row v-if="norecordsfound">
                    <ion-col size="12" class="pagination-info ion-text-center">
                        <ion-label class="pagination-info">No records found for the selected filters</ion-label>
                    </ion-col>
                </ion-row>
            </ion-grid>
            <div class="spinner">
                <ion-spinner v-if="loaderTab"></ion-spinner>
            </div>
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import { EVCStationService } from "../../service/evcstation/stations.service";
import { EVCStation, EVCStationStatus } from "../../entity/location/evcstation";
import { refresh } from 'ionicons/icons';
import { ToastUtils } from "../../util/toast-utils";
import { PaginationUtils } from "../../util/pagination-utils";
// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datepicker from 'vue3-datepicker';
import moment from "moment";
import userData from "../../../public/assets/data/data.json";


export default defineComponent ({
    name: "carterStations",
    components: {
        datepicker, IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonButton, IonIcon, IonSpinner
    },
    data() {
        return {
            refresh,
            loaderTab: true,
            // stations: [
            //     {
            //     "id": 10000057,
            //     "name": "VCOC / STATION 01",
            //     "effectiveOn": "2023-05-09T18:30:00.000Z",
            //     "effectiveTill": "9999-12-30T18:30:00.000Z",
            //     "org" : "CMA's Volvo Cars of Charlottesville",
            //     "serialNumber" : 210241002187,
            //     "make" : "ChargePoint",
            //     "model": "CT4020-HD-GW",
            //     "activationDate" : "2023-01-09T16:58:19.000Z",
            //     "noOfPorts" : 2,
            //     "ports" : [
            //         {
            //             "portInfo" : "240V / 50A {50A} / J1772 / Single Phase AC",
            //             "portStatus" : {
            //                 "id" : "AV",
            //                 "name" : "AVAILABLE"
            //             },
            //         },
            //         {
            //             "portInfo" : "240V / 50A {50A} / J1772 / Single Phase AC",
            //             "portStatus" : {
            //                 "id" : "OC",
            //                 "name" : "OCCUPIED"
            //             },
            //         }
            //     ],
            //     "status": {
            //         "id": "AV",
            //         "name": "Available"
            //     },
            //     "visibilityStatus": {
            //         "id": "Y",
            //         "name": "Yes"
            //     },
            //     "thirdPartyStatus": {
            //         "id": "N",
            //         "name": "NO"
            //     },
            //     "address": {
            //         "line1": "CMA's Volvo Cars of Charlottesville",
            //         "city": "Charlottesville",
            //         "state": {
            //             "code": "VN",
            //             "name": "Virginia"
            //         },
            //         "zipcode": "22901"
            //     },
            //     "landline": "04222975205",
            //     "mobile": "9894360205",
            //     "email": "support@rapidevcharge.com",
            //     "coordinate": {
            //         "latitude": "38.085709623884284",
            //         "longitude": "-78.462637524490430"
            //     },
            //     "hoursOfOperations": [
            //         {
            //             "weekDay": 0,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 1,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 2,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 3,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 4,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 5,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 6,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 7,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         }
            //     ],
            //     "distributionNode": "",
            //     "distance": {
            //         "value": 92.81,
            //         "unit": "km",
            //         "description": "92.81km away"
            //     },
            //     "rating": "4.5"
            //     },
            //     {
            //     "id": 10000058,
            //     "name": "VCOC / SHOP GW 01",
            //     "effectiveOn": "2023-01-09T16:58:19.000Z",
            //     "effectiveTill": "9999-12-30T18:30:00.000Z",
            //     "org" : "CMA's Volvo Cars of Charlottesville",
            //     "serialNumber" : 223441074391,
            //     "make" : "ChargePoint",
            //     "model": "CPGW",
            //     "activationDate" : "2023-04-12T12:36:37.000Z",
            //     "noOfPorts" : 0,
            //     "ports" : [],
            //     "status": {
            //         "id": "AV",
            //         "name": "Available"
            //     },
            //     "visibilityStatus": {
            //         "id": "Y",
            //         "name": "Yes"
            //     },
            //     "thirdPartyStatus": {
            //         "id": "N",
            //         "name": "NO"
            //     },
            //     "address": {
            //         "line1": "CMA's Volvo Cars of Charlottesville",
            //         "line2": "Kaithiyan Kottai Village",
            //         "line3": "NH 7 Vidhuthalaipatti",
            //         "landmark": "",
            //         "city": "Charlottesville",
            //         "state": {
            //             "code": "VN",
            //             "name": "Virginia"
            //         },
            //         "zipcode": "22901"
            //     },
            //     "landline": "04222975205",
            //     "mobile": "9894360205",
            //     "email": "support@rapidevcharge.com",
            //     "coordinate": {
            //         "latitude": "38.086297200000004",
            //         "longitude": "-78.476005442327870"
            //     },
            //     "hoursOfOperations": [
            //         {
            //             "weekDay": 0,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 1,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 2,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 3,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 4,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 5,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 6,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 7,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         }
            //     ],
            //     "distributionNode": "",
            //     "distance": {
            //         "value": 92.81,
            //         "unit": "km",
            //         "description": "92.81km away"
            //     },
            //     "rating": "4.5"
            //     },
            //     {
            //     "id": 10000059,
            //     "name": "VCOC / SHOP 02",
            //     "effectiveOn": "2023-05-09T18:30:00.000Z",
            //     "effectiveTill": "9999-12-30T18:30:00.000Z",
            //     "org" : "CMA's Volvo Cars of Charlottesville",
            //     "serialNumber" : 211841018140,
            //     "make" : "ChargePoint",
            //     "model": "CPF50-L23-PEDMNT-CMK8",
            //     "activationDate" : "2023-05-15T15:18:27.000Z",
            //     "noOfPorts" : 1,
            //     "ports" : [
            //         {
            //             "portInfo" : "240V / 50A {50A} / J1772 / Single Phase AC",
            //             "portStatus" : {
            //                 "id" : "AV",
            //                 "name" : "AVAILABLE"
            //             },
            //         }
            //     ],
            //     "status": {
            //         "id": "AV",
            //         "name": "Available"
            //     },
            //     "visibilityStatus": {
            //         "id": "Y",
            //         "name": "Yes"
            //     },
            //     "thirdPartyStatus": {
            //         "id": "N",
            //         "name": "NO"
            //     },
            //     "address": {
            //         "line1": "CMA's Volvo Cars of Charlottesville",
            //         "line2": "Kaithiyan Kottai Village",
            //         "line3": "NH 7 Vidhuthalaipatti",
            //         "landmark": "",
            //         "city": "Charlottesville",
            //         "state": {
            //             "code": "VN",
            //             "name": "Virginia"
            //         },
            //         "zipcode": "22901"
            //     },
            //     "landline": "04222975205",
            //     "mobile": "9894360205",
            //     "email": "support@rapidevcharge.com",
            //     "coordinate": {
            //         "latitude": "38.086297200000000",
            //         "longitude": "-78.476026900000000"
            //     },
            //     "hoursOfOperations": [
            //         {
            //             "weekDay": 0,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 1,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 2,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 3,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 4,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 5,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 6,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 7,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         }
            //     ],
            //     "distributionNode": "",
            //     "distance": {
            //         "value": 92.81,
            //         "unit": "km",
            //         "description": "92.81km away"
            //     },
            //     "rating": "4.5"
            //     },
            //     {
            //     "id": 10000060,
            //     "name": "VCOC / SHOP 01",
            //     "effectiveOn": "2023-05-09T18:30:00.000Z",
            //     "effectiveTill": "9999-12-30T18:30:00.000Z",
            //     "org" : "CMA's Volvo Cars of Charlottesville",
            //     "serialNumber" : 211841018127,
            //     "make" : "ChargePoint",
            //     "model": "CPF50-L23-PEDMNT-CMK8",
            //     "activationDate" : "2023-05-15T15:19:31.000Z",
            //     "noOfPorts" : 1,
            //     "ports" : [
            //         {
            //             "portInfo" : "240V / 50A {50A} / J1772 / Single Phase AC",
            //             "portStatus" : {
            //                 "id" : "OC",
            //                 "name" : "OCCUPIED"
            //             },
            //         }
            //     ],
            //     "status": {
            //         "id": "OC",
            //         "name": "Occupied"
            //     },
            //     "visibilityStatus": {
            //         "id": "Y",
            //         "name": "Yes"
            //     },
            //     "thirdPartyStatus": {
            //         "id": "N",
            //         "name": "NO"
            //     },
            //     "address": {
            //         "line1": "CMA's Volvo Cars of Charlottesville",
            //         "line2": "Kaithiyan Kottai Village",
            //         "line3": "NH 7 Vidhuthalaipatti",
            //         "landmark": "",
            //         "city": "Charlottesville",
            //         "state": {
            //             "code": "VN",
            //             "name": "Virginia"
            //         },
            //         "zipcode": "22901"
            //     },
            //     "landline": "04222975205",
            //     "mobile": "9894360205",
            //     "email": "support@rapidevcharge.com",
            //     "coordinate": {
            //         "latitude": "38.086284533279134",
            //         "longitude": "-78.476059086508170"
            //     },
            //     "hoursOfOperations": [
            //         {
            //             "weekDay": 0,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 1,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 2,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 3,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 4,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 5,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 6,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         },
            //         {
            //             "weekDay": 7,
            //             "opensAt": {
            //                 "hour": 0,
            //                 "minute": 0
            //             },
            //             "closesAt": {
            //                 "hour": 23,
            //                 "minute": 59
            //             }
            //         }
            //     ],
            //     "distributionNode": "",
            //     "distance": {
            //         "value": 92.81,
            //         "unit": "km",
            //         "description": "92.81km away"
            //     },
            //     "rating": "4.5"
            //     },
                
            // ],
            stations: userData.stationInfo,
            statuses: [],
            statusModels: [],
            id: "",
            name: "",
            city: "",
            effectiveFrom: "",
            effectiveTo: "",
            status: "",

            norecordsfound: false,
            totalRecords: 0,
            pageRecords: 15,
            pageNo: 1,
            pagesList: [],
            totalPages: 0,
            stationsList: [],
            chargerStatus: null,
            displayBackBtn: false
        }
    },
    async mounted() {
        this.chargerStatus = JSON.parse(localStorage.getItem('stationList'));
        if(this.chargerStatus == null) {
            this.stationsList = this.stations;
            this.displayBackBtn = true;
        } else {
            this.stationsList = this.chargerStatus;
        }        
        var search = localStorage.getItem('stationSearch');
        if (search) {
            search = JSON.parse(search);
            this.name = search.name;
            this.city = search.city;
            document.getElementById("name").value = search.name;
            document.getElementById("city").value = search.city;
            this.effectiveFrom = search.effectiveFrom;
            this.effectiveTo = search.effectiveTo;
            this.status = search.status;
            await this.searchStations();
        }
        this.loaderTab = false;
    },
    methods: {
        
        navigatePreviousPage() {
        this.$router.go(-1)
        },
        changeDateFormat(dateValue) {
            return moment(dateValue).format('YYYY-MM-DD HH:mm:ss')
        },
        changeDateFormatWithoutTime(dateValue) {
            if(dateValue != null) {
                return moment(dateValue).format('DD/MMM/YYYY')
            }
        },
        convertUppercase(value) {
            return value.toUpperCase()
        },
        addStation() {
            this.$router.push("/admin/chargingstations/station");
        },
        viewStation(stationDetails) {
            localStorage.setItem("stationDetailForView", JSON.stringify(stationDetails));
            this.$router.push("carterStationDetatils");
        },
        clearFields() {
            this.name = null;
            this.city = null;
            document.getElementById("name").value = null;
            document.getElementById("city").value = null;
            this.effectiveFrom = null;
            this.effectiveTo = null;
            this.status = null;
            localStorage.removeItem('stationSearch');
            localStorage.removeItem('stationPage');
            this.stationsList = [];
            // this.stationsList = this.stations;
            this.norecordsfound = false;
        },
        async searchStations() {
            // this.stationsList = this.stations
            this.stationsList = [];
            let listOfStation= []
            if((this.name == null || this.name == '') && (this.city == null || this.city == '')) {
                this.stationsList = this.stations
            } else {
                this.stations.forEach((station) => {
                    if((this.name != '' && this.name != null) && (this.city != null && this.city != '')) {
                        if((((station.name).toLocaleLowerCase()).match((this.name).toLocaleLowerCase())) && (((station.address.city).toLocaleLowerCase()).match((this.city).toLocaleLowerCase()))) {
                            listOfStation.push(station)
                        }
                    }

                    if((this.name != '' || this.name != null) && (this.city == null || this.city == '')) {
                        if(((station.name).toLocaleLowerCase()).match((this.name).toLocaleLowerCase())) {
                            listOfStation.push(station)
                        }
                    }
                    if((this.name == '' || this.name == null) && (this.city != null || this.city != '')) {
                        if(((station.address.city).toLocaleLowerCase()).match((this.city).toLocaleLowerCase())) {
                            listOfStation.push(station)
                        }
                    }
                })
                if(listOfStation.length > 0) {
                    this.stationsList = listOfStation;
                } else {
                    this.norecordsfound = true;
                }
            }
            
           
            
        },
    }
})
</script>
<style scoped>
.ext-link {
  /* text-align: left;
  font-family: "Roboto Medium";
  font-size: 13px;
  letter-spacing: 0;
  color: #21b24b;
  opacity: 1; */
  cursor: pointer;
}
.station-name{
    font-weight: bold;
    /* color: #c8412b; */
    color: #0e3457;
}
.list-head ion-label{
    padding:5px;
    color: #041648;
    font-size: 13px;
    font-weight: bold;
}
.station-list {
    padding: 5px;
    font-size: 13px;
    border-bottom: 1px solid grey;
    background: #dadcdf;
}
.title-wrapper ion-title {
    font-weight: 500;
    padding-top: 0px;
    /* padding-top: 15px; */
    margin-left: 45px;
    position: static;
    
    font-family: "Roboto";
    font-size: 15px;
    color: #495057;
    /* top: 6px; */
}

.avalilable {
    color: #77c44f;
    font-size: 12px;
    font-weight: bold;
    font-size: 11px;
    padding: 5px;
    border-radius: 5px;
    background: white;
    opacity: 0.8;
    
}
.occupied {
    color: #74a5cb;
    font-weight: bold;
    padding: 5px;
    border-radius: 5px;
    background: white;
    font-size: 11px;
    opacity: 0.8;
}
.unavailable {
    color: #bcbab6;
    font-weight: bold;
    padding: 0 10px 0 10px;
    padding: 5px;
    border-radius: 5px;
    background: white;
    font-size: 11px;
}
.faulted {
    color: #d9593c;
    font-weight: bold; 
    padding: 0 10px 0 10px;
    /* border: 1px solid #77c44f; */
    font-size: 11px;
    border-radius: 3px;
}
.unreachable {
    color: #d7d52c;
    font-weight: bold;
    padding: 0 10px 0 10px;
    /* border: 1px solid #77c44f; */
    font-size: 11px
}
</style>